import { ungzip } from 'pako';

/**
 * Decompress gzipped ArrayBuffer if needed
 * @param {ArrayBuffer} data - Raw data from FileLoader
 * @param {boolean} asString - Return string if true, Uint8Array if false
 * @returns {Uint8Array | string}
 */
export function decompressIfGzip(data, asString = false) {
	let byteArray = new Uint8Array(data);

	// Detect gzip: first two bytes are 0x1f 0x8b
	const isGzip = byteArray[0] === 0x1f && byteArray[1] === 0x8b;

	if (isGzip) {
		byteArray = ungzip(byteArray);
	}

	if (asString) {
		return new TextDecoder('utf-8').decode(byteArray);
	}

	return byteArray;
}
